import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AreaModel } from "../../models/regions/area";
import { CityModel } from "../../models/regions/city";
import { CountryModel } from "../../models/regions/country";
import { AreaService } from "src/services/regions/areaService";
import { CityService } from "src/services/regions/cityService";

interface RegionState {
  areas: AreaModel[],
  cities: CityModel[],
  countries: CountryModel[]
}

const initialState: RegionState = {
  areas: [],
  cities: [],
  countries: []
};

const regionSlice = createSlice({
  name: "region",
  initialState,
  reducers: {
    removeArea: (state, action: PayloadAction<number>) => {
      state.areas.
        splice(
          state.areas.
            findIndex((area) => area.id === action.payload), 1)
    },
    updateArea: (state, action: PayloadAction<AreaModel>) => {
      let index = state.areas.
        findIndex((area) => area.id === action.payload.id)
      if (index > -1) {
        state.areas[index] = action.payload;
      }
    },
    addAreaToStore: (state, action: PayloadAction<AreaModel>) => {
      let index = state.areas.
        findIndex((area) => area.id === action.payload.id)
      if (index < 0) {
        state.areas.push(action.payload)
      }
    },
    removeCity: (state, action: PayloadAction<number>) => {
      state.cities.
        splice(
          state.cities.
            findIndex((city) => city.id === action.payload), 1)
    },
    updateCity: (state, action: PayloadAction<CityModel>) => {
      let index = state.cities.
        findIndex((city) => city.id === action.payload.id);
      if (index > -1) {
        state.cities[index] = action.payload;
      }
    },
    addCityToStore: (state, action: PayloadAction<CityModel>) => {
      let index = state.cities.
        findIndex((city) => city.id === action.payload.id)
      if (index < 0) {
        state.cities.push(action.payload)
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addAreasAsync.pending, () => {
        console.log("addAreasAsync.pending");
      })
      .addCase(
        addAreasAsync.fulfilled,
        (state, action: PayloadAction<AreaModel[]>) => {
          state.areas = action.payload
        }
      ).addCase(addCitiesAsync.pending, () => {
        console.log("addCitiesAsync.pending");
      })
      .addCase(
        addCitiesAsync.fulfilled,
        (state, action: PayloadAction<CityModel[]>) => {
          state.cities = action.payload
        }
      );
  },
});

export const addAreasAsync = createAsyncThunk(
  "area/getall",
  async () => {
    return await AreaService.getAllArea();
  }
);

export const addCitiesAsync = createAsyncThunk(
  "city/getall",
  async () => {
    return await CityService.getAllCity();
  }
);


export const { updateArea, removeArea, addAreaToStore, removeCity, updateCity,addCityToStore } = regionSlice.actions;
export default regionSlice.reducer;